import t from '@instructure/quiz-i18n/es/format-message';
import { saveAs } from 'file-saver';
var formatNumbers = function formatNumbers(value) {
  if (typeof value === 'number') {
    return t.number(value);
  }
  return value;
};
var getSanitizedMetricValue = function getSanitizedMetricValue(value, suffix) {
  if (value === null || value === undefined) {
    return t('N/A');
  }
  var formattedValue = formatNumbers(value);
  return suffix ? formattedValue + suffix : formattedValue;
};
export var saveFile = function saveFile(file, fileName) {
  saveAs(file, fileName);
};
export { getSanitizedMetricValue };